import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex flex-col justify-center overflow-hidden pt-20 pb-20" data-id="element-38">
      {/* Background Grid Lines - Swiss Style */}
      <div className="absolute inset-0 pointer-events-none z-0 opacity-[0.03]" data-id="element-39">
        <div className="h-full w-full grid grid-cols-12 gap-4" data-id="element-40">
          {[...Array(12)].map((_, i) => <div key={i} className="h-full border-r border-black last:border-r-0" data-id="element-41" />)}
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-42">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end" data-id="element-43">
          {/* Main Content - Asymmetric Layout */}
          <div className="lg:col-span-7 flex flex-col" data-id="element-44">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} data-id="element-45">
              <h2 className="text-sm font-bold tracking-[0.2em] uppercase mb-6 text-gray-500" data-id="element-46">
                Virtual Assistant Automation
              </h2>
              <h1 className="text-5xl md:text-7xl font-black tracking-tight leading-[0.9] mb-8" data-id="element-47">
                Automate the <br data-id="element-48" />
                <span className="text-[#84cc16]" data-id="element-49">mundane.</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 max-w-lg leading-relaxed mb-10 font-medium" data-id="element-50">
                Joueurlibre streamlines your workflow with precision-engineered
                virtual assistants.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-51">
                <Button withArrow data-id="element-52">Start Automating</Button>
                <Button variant="outline" data-id="element-53">View Case Studies</Button>
              </div>
            </motion.div>
          </div>

          {/* Massive Stat - The Focal Point */}
          <div className="lg:col-span-5 flex flex-col justify-end lg:items-end mt-12 lg:mt-0" data-id="element-54">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'circOut'
          }} className="relative" data-id="element-55">
              <div className="absolute -top-12 -left-12 w-24 h-24 bg-[#84cc16] rounded-full mix-blend-multiply opacity-20 blur-xl animate-pulse" data-id="element-56" />

              <h2 className="text-[8rem] md:text-[10rem] lg:text-[12rem] font-black leading-none tracking-tighter text-black" data-id="element-57">
                340
                <span className="text-[4rem] md:text-[6rem] align-top text-[#84cc16]" data-id="element-58">
                  %
                </span>
              </h2>
              <p className="text-right text-xl font-bold tracking-tight mt-2 border-t-4 border-[#84cc16] pt-4 inline-block float-right" data-id="element-59">
                FASTER EXECUTION
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}